import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Coupoun } from "../../types/modules/admin/coupoun.type";

interface UseParams {
  page?: number;
  limit?: number;
}

export const useCoupounsByAdmin = ({ page = 1, limit = 10 }: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  return useQuery({
    queryKey: ["coupons-by-admin", page, limit],
    queryFn: () =>
      fetcher<{ data: Coupoun[]; total: number; totalPages: number }>(
        `coupon/admin?${queryParams.toString()}`,
        token
      ),
  });
};
